import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';

import { type ActiveTableConfig, type FocusTableConfig, MessageType } from '../types/types';

import useOpenActiveTable from './useOpenActiveTable';

interface Props {
  tableUrl?: string;
}

const useOpenActiveGame = ({ tableUrl }: Props = {}) => {
  const activeTableButtonEnabled = useFeature(FeatureFlag.PKRNavigationActiveTableButton);
  const { openActiveTable } = useOpenActiveTable();

  const openActiveGame = () => {
    if (!tableUrl) return;

    if (activeTableButtonEnabled) {
      const urlParams = new URLSearchParams(tableUrl);
      let args: ActiveTableConfig | undefined;
      try {
        const base64args = urlParams.get('args') || '';
        args = JSON.parse(atob(base64args)) as ActiveTableConfig;
        if (args) {
          openActiveTable({
            type: MessageType.OPEN_GAME,
            data: args
          });
        }
      } catch {
        return;
      }
    } else {
      window.open(tableUrl, '_blank', 'noreferrer');
    }
  };

  const focusActiveGame = (data: FocusTableConfig) => {
    if (activeTableButtonEnabled) {
      openActiveTable({
        type: MessageType.FOCUS_GAME,
        data
      });
    }
  };

  return { openActiveGame, focusActiveGame };
};

export default useOpenActiveGame;
